import { NodeRequestOptions } from '../../data/node-connection';
import { MediaConversion, MediaConversionBase } from '../../data/units';

/**
 * Server Inventory detail query parameters.
 */
export interface ServerInventoryDetailParams {
    /**
     * name of server node.
     */
    name: string;

    /**
     * options for Node request.
     */
    requestOptions?: NodeRequestOptions;
}

/**
 * Server Inventory detail data interface.
 */
export interface ServerInventoryDetailData {
    /**
     * The server name.
     */
    serverName: string;

    /**
     * The list of processor names.
     */
    processors: string[];

    /**
     * The total memory capacity. (bytes)
     */
    totalMemory: number;

    /**
     * The total disk capacity. (bytes)
     */
    totalDisk: number;

    /**
     * The number of physical NICs.
     */
    totalPhysicalNics: number;

    /**
     * The free disk space. (bytes)
     */
    totalFreeDiskSpace: number;
}

/**
 * Server Inventory Detail class.
 */
export class ServerInventoryDetail implements ServerInventoryDetailData {
    /**
     * The list of processor names.
     */
    public processors: string[] = [];

    /**
     * The total memory capacity.
     */
    public totalMemory = 0;

    /**
     * The total disk capacity.
     */
    public totalDisk = 0;

    /**
     * The number of sockets.
     */
    public sockets: string[];

    /**
     * The number of physical NICs.
     */
    public totalPhysicalNics = 0;

    /**
     * The free disk space.
     */
    public totalFreeDiskSpace = 0;

    /**
     * Initializes a new instance of the ServerInventory Class.
     *
     * @param serverName the server name to query.
     * @param data the server inventory recovered data.
     */
    constructor(public serverName: string, data?: ServerInventoryDetailData) {
        if (data) {
            Object.assign(this, data);
        }
    }

    /**
     * Gets display name of processors.
     */
    public get processorsDisplayName(): string {
        return this.processors.join('\n');
    }

    /**
     * Gets the display name of total memory capacity.
     */
    public get totalMemoryDisplayName(): string {
        return MediaConversion.getConvertedValue(this.totalMemory, MediaConversionBase.Binary);
    }

    /**
     * Gets the display name of total disk capacity.
     */
    public get totalDiskDisplayName(): string {
        return  MediaConversion.getConvertedValue(this.totalDisk, MediaConversionBase.Binary);
    }

    /**
     * Gets the display name of free space on disk.
     */
    public get freeDiskDisplayName(): string {
        return  MediaConversion.getConvertedValue(this.totalFreeDiskSpace, MediaConversionBase.Binary);
    }
}
